var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","outlined":"","small":"","loading":_vm.loading},on:{"click":_vm.handleEmail}},[_c('v-icon',{attrs:{"icon":"","left":"","small":""}},[_vm._v("mdi-email")]),_c('span',{staticClass:"text-notransform"},[_vm._v("Email Again")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }